const getTemplateImageUrlByCode = (code: string) => {
  return require(`./images/${code}.png`)?.default?.src
}

export default getTemplateImageUrlByCode
